<div class="dialog">
    <div class="dialog-header">
        『文件题名』规则
    </div>
    <div class="dialog-body">
        <div class="grid">
            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">
                    固定前部
                </div>
                <div class="column" [style.width]="600 + 'px'">
                    <input type="text" placeholder="请输入案卷题名前面固定部分（可以没有）" [(ngModel)]="record.titleFixedPrefix"
                        (ngModelChange)="genExampleName()">
                </div>
            </div>

            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">
                    表单信息
                </div>
                <div class="column" [style.width]="30 + 'px'">
                    <input type="checkbox" [(ngModel)]="fileTitleRuleFormInfosCode.checked"
                        (ngModelChange)="genExampleName()">
                </div>
                <div class="column no-border-left" [style.width]="60 + 'px'">
                    表单代号
                </div>
                <div class="column no-border-left" [style.width]="110 + 'px'">
                    <input type="text" placeholder="请输入间隔符" [(ngModel)]="fileTitleRuleFormInfosCode.separator"
                        (ngModelChange)="genExampleName()">
                </div>
                <div class="column" [style.width]="30 + 'px'">
                    <input type="checkbox" [(ngModel)]="fileTitleRuleFormInfosName.checked"
                        (ngModelChange)="genExampleName()">
                </div>
                <div class="column no-border-left" [style.width]="60 + 'px'">
                    表单名称
                </div>
                <div class="column no-border-left" [style.width]="110 + 'px'">
                    <input type="text" placeholder="请输入间隔符" [(ngModel)]="fileTitleRuleFormInfosName.separator"
                        (ngModelChange)="genExampleName()">
                </div>
                <div class="column" [style.width]="30 + 'px'">
                    <input type="checkbox" [(ngModel)]="fileTitleRuleFormInfosSn.checked"
                        (ngModelChange)="genExampleName()">
                </div>
                <div class="column no-border-left" [style.width]="60 + 'px'">
                    文件编码
                </div>
                <div class="column no-border-left" [style.width]="110 + 'px'">
                    <input type="text" placeholder="请输入结尾字符" [(ngModel)]="fileTitleRuleFormInfosSn.separator"
                        (ngModelChange)="genExampleName()">
                </div>
            </div>

            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column background-page spin"
                    [style.height]="(hasMaterial ? 6 : headers.length + 3) * 40 + 'px'" [style.top]="0" [style.left]="0"
                    [style.width]="70 + 'px'">
                    自动部分
                </div>
                <div class="column background-page" [style.width]="160 + 'px'">
                    参与项
                </div>
                <div class="column background-page" [style.width]="40 + 'px'">
                    参与
                </div>
                <div class="column background-page" [style.width]="360 + 'px'">
                    示例
                </div>
                <div class="column background-page" [style.width]="40 + 'px'">
                    间隔
                </div>
            </div>
            <div class="row" *ngFor="let item of hasMaterial ? [] : headers">
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="item.name ?? ''" [patternStr]="'C000000@@E+160'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()" [(ngModel)]="item.nameRuleChecked">
                </div>
                <div class="column" [style.width]="360 + 'px'">
                    <format-data [contentStr]="'['+ item.name +']'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()" [(ngModel)]="item.separator">
                </div>
            </div>
            <div class="row" *ngIf="hasMaterial">
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data contentStr="材料名称" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="materialTypeRule.params![0].checked">
                </div>
                <div class="column" [style.width]="360 + 'px'">
                    <format-data [contentStr]="'钢筋'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="materialTypeRule.params![0].separator">
                </div>
            </div>
            <div class="row" *ngIf="hasMaterial">
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data contentStr="规格型号" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="materialModelRule.params![0].checked">
                </div>
                <div class="column" [style.width]="360 + 'px'">
                    <format-data [contentStr]="'HPB300Φ10'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="materialModelRule.params![0].separator">
                </div>
            </div>
            <div class="row" *ngIf="hasMaterial">
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data contentStr="材料批次" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="materialBatchRule.params![0].checked">
                </div>
                <div class="column" [style.width]="360 + 'px'">
                    <format-data [contentStr]="' ZJJG-GJ-Φ10-0001'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="materialBatchRule.params![0].separator">
                </div>
            </div>
            <div class="row" *ngIf="hasMaterial">
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data contentStr="提交日期" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="submitDateRule.params![0].checked">
                </div>
                <div class="column" [style.width]="360 + 'px'">
                    <format-data [contentStr]="'2023-02-28'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="submitDateRule.params![0].separator">
                </div>
            </div>
            <div class="row" *ngIf="hasMaterial">
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data contentStr="完成日期" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="finishDateRule.params![0].checked">
                </div>
                <div class="column" [style.width]="360 + 'px'">
                    <format-data [contentStr]="'2023-03-20'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="finishDateRule.params![0].separator">
                </div>
            </div>

            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">
                    固定后部
                </div>
                <div class="column" [style.width]="600 + 'px'">
                    <input type="text" placeholder="请输入案卷题名后面固定部分（可以没有）" [(ngModel)]="record.titleFixedSuffix"
                        (ngModelChange)="genExampleName()">
                </div>
            </div>


            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">
                    卷名示例
                </div>
                <div class="column background-module" [style.width]="600 + 'px'">
                    <format-data class="color-primary" [contentStr]="exampleName" [patternStr]="'E+600'"></format-data>
                </div>
            </div>

            <div class="row">
                <div class="column no-border" [style.width]="670 + 'px'">
                    <label class="color-primary" nz-checkbox [(ngModel)]="forceUpdate">
                        用新规则刷新已有文件题名（不勾选，本目录下已有文件题名将不更新）
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button nz-button nzType="default" (click)="cancel()">取消</button>
        <button nz-button nzType="primary" (click)="confirm()" [disabled]="!canConfirm">确认</button>
    </div>
</div>